import React from 'react';
import { Box, Typography } from '@material-ui/core';
import styles from './index.module.css';
import { ReactComponent as BannerImage } from 'assets/images/onboarding-illustration.svg';
const OnboardingBanner = () => {
    return (
        <Box className={styles.onboardingBanner}>
            <BannerImage className={styles.bannerImage} />
            <Box>
                <Typography className={styles.bannerText}>
                    This is only meant to be a live demonstration of Medallion<sup>TM</sup>.
                </Typography>
            </Box>
        </Box>
    );
};

export default OnboardingBanner;
